import { useEffect, useRef, useState } from 'preact/hooks';
import { sfx } from '../../audio/sfx.ts';
import { t } from '../../i18n/index.ts';
import { serverNow } from '../../net/client.ts';

export function useRemaining(endsAt: number): number {
  const [remaining, setRemaining] = useState(() => Math.max(0, endsAt - serverNow()));
  useEffect(() => {
    const tick = () => setRemaining(Math.max(0, endsAt - serverNow()));
    tick();
    const id = window.setInterval(tick, 250);
    return () => window.clearInterval(id);
  }, [endsAt]);
  return remaining;
}

export function Timer({ endsAt, total }: { endsAt: number; total?: number }) {
  const remaining = useRemaining(endsAt);
  const seconds = Math.ceil(remaining / 1000);
  const lastTick = useRef(0);
  useEffect(() => {
    if (seconds > 0 && seconds <= 5 && seconds !== lastTick.current) {
      lastTick.current = seconds;
      sfx.tick();
    }
  }, [seconds]);

  const label = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
  const fraction = total ? Math.min(1, remaining / total) : null;
  return (
    <div class={`timer ${seconds <= 10 ? 'timer--urgent' : ''}`} role="timer" aria-label={`${t('timer.label')} ${label}`}>
      <span class="timer__digits" aria-hidden="true">
        {label}
      </span>
      {fraction !== null && <span class="timer__fuse" style={{ transform: `scaleX(${fraction})` }} aria-hidden="true" />}
    </div>
  );
}
